import { ProductUpcRouteService } from 'common/data';
import { BaseService } from 'core/services';
import { findParams } from 'core/utils';

class ProductUpcService extends BaseService {
	constructor(apiClient) {
		super(apiClient, new ProductUpcRouteService());
	}

	find(filter) {
		var url = this.routeService.find(filter);
		return this.apiClient.post(url, findParams(filter));
	}
}

export default ProductUpcService;



// WEBPACK FOOTER //
// ./src/common/data/services/ProductUpcService.js